import DeviceDetector from "device-detector-js";
import { capitalizeFirstLetter} from ".";

export const getDeviceClientData = () => {
  const deviceDetector = new DeviceDetector();
  const {userAgent} = navigator;
  const { client, device, os } = deviceDetector.parse(userAgent);
  
  return `${capitalizeFirstLetter(device.type)}/1.0; ${os.name}/${os.version}; ${client.name}/${client.version}; SELO_D_AGUA/1.0`;
};